import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from "@angular/core";

/** Floating mini cart under the header cart icon; a bottom sheet below the lg breakpoint. */
@Component({
  selector: "app-header-cart-panel",
  templateUrl: "./header-cart-panel.component.html",
  styleUrls: ["./header-cart-panel.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderCartPanelComponent {
  @Input() panelId: string;
  @Input() open = false;
  @Input() rentalCount = 0;
  @Input() shopCount = 0;
  @Input() showShop = false;
  /** Emits true when focus should return to the cart icon. */
  @Output() dismiss = new EventEmitter<boolean>();

  get empty(): boolean { return !this.rentalCount && !(this.showShop && this.shopCount); }

  itemLabel(count: number): string { return `${count} ${count === 1 ? "item" : "items"}`; }
}
